"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.GridEditorView = undefined;

var _defineProperty = require("babel-runtime/core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require("babel-runtime/core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require("babel-runtime/helpers/get");

var _get3 = _interopRequireDefault(_get2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _dec5, _dec6, _class3, _class4, _temp;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _mobxReact = require("mobx-react");

var _simboxEditable = require("simbox-editable");

var _editor = require("simbox-editable/editor");

var _editor2 = _interopRequireDefault(_editor);

var _mobx = require("mobx");

var _agGridReact = require("ag-grid-react");

var _mixwith = require("mixwith");

var _layoutComponent = require("layout-component");

var _baseComponent = require("base-component");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = require("base-viewstore");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseContentmodel = require("base-contentmodel");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

require("ag-grid/dist/styles/ag-grid.css");

require("ag-grid/dist/styles/theme-fresh.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var ViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_DefaultEditorViewSto) {
  (0, _inherits3.default)(ViewStore, _DefaultEditorViewSto);
  (0, _createClass3.default)(ViewStore, [{
    key: "viewMap",
    get: function get() {
      return this.collection.reduce(function (acc, item) {
        acc[item.id] = {
          id: item.id,
          contentModel: item.contentModel || item
        };

        (0, _keys2.default)(item.slots).filter(function (k) {
          return item.slots[k] && (item.slots[k].prototype instanceof _baseContentmodel2.default || item.slots[k] === _baseContentmodel2.default);
        }).forEach(function (k) {
          var subCm = item[k];
          if (!subCm) return;
          acc[subCm.id] = {
            id: subCm.id,
            contentModel: subCm.contentModel || subCm
          };
        });

        return acc;
      }, {});
    }
    /** end view controller mixin overrides **/

    /** local ViewStore class **/

  }]);

  function ViewStore() {
    (0, _classCallCheck3.default)(this, ViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ViewStore.__proto__ || (0, _getPrototypeOf2.default)(ViewStore)).apply(this, arguments));

    _this.dispose = [];

    _initDefineProp(_this, "api", _descriptor, _this);

    _initDefineProp(_this, "selectedCollectionName", _descriptor2, _this);

    var options = _this.props.options;

    _this.selectedCollectionName = options && options.collection ? options.collection : _this.availableCollectionNames[0] || "";
    _this.dispose.push((0, _mobx.reaction)(function () {
      return _this.selectedCollectionName;
    }, function () {
      return _this.props.editorViewStore.stopEditing();
    }));
    return _this;
  }

  (0, _createClass3.default)(ViewStore, [{
    key: "setCollection",
    value: function setCollection(val) {
      this.selectedCollectionName = val;
    }
  }, {
    key: "formatTitle",
    value: function formatTitle(propertyName) {
      return propertyName.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    }
  }, {
    key: "updateGrid",
    value: function updateGrid() {
      var contentModel = this.contentModel;

      if (window.GRIDUPDATE && window.GRIDUPDATE[contentModel.id]) {
        window.GRIDUPDATE[contentModel.id].forceUpdate();
      }
    }

    // no @action since calling super

  }, {
    key: "editItem",
    value: function editItem(item, node) {
      var _this2 = this;

      if (item.readonly) return;
      // super === DefaultEditorViewStore
      (0, _get3.default)(ViewStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(ViewStore.prototype), "editItem", this).call(this, item);
      if (typeof this.disposeEdit === "function") this.disposeEdit();
      if (node) {
        this.disposeEdit = (0, _mobx.reaction)(function () {
          return (0, _keys2.default)(item).map(function (k) {
            return item[k], (0, _typeof3.default)(item[k]) === "object" && item[k].length;
          });
        }, function () {
          return _this2.api.refreshRows([node]);
        });
      }
    }
  }, {
    key: "newItem",
    value: function newItem() {
      var _this3 = this;

      if (this.CollectionItemContentModel === _baseContentmodel2.default) return;
      var num = getRandomIntInclusive(0, 1000);
      var item = new this.CollectionItemContentModel({
        id: this.CollectionItemContentModel.name.replace("ContentModel", "") + "_" + num
      });

      var editorViewStore = this.props.editorViewStore;

      editorViewStore.startEditing({
        contentModel: item,
        onSave: function onSave(item) {
          _this3.collection.indexOf(item) === -1 && _this3.collection.push(item);
          _this3.contentModel.saveEntity();
          _this3.api.ensureNodeVisible(item);

          // if(typeof this.dispose === "function") this.dispose();
          // this.dispose = reaction( 
          //   () => Object.keys(item).map( k => (item[k], typeof item[k] === "object" && item[k].length) ),
          //   () => {
          //     const nodes = this.api.getRenderedNodes();
          //     this.api.refreshRows( [nodes[nodes.length-1]] )
          //   }
          // )    
        }
      });
    }
  }, {
    key: "collectionIsArray",
    get: function get() {
      if (!this.selectedCollectionName) throw new Error("no selectedCollectionName selected");
      var slots = this.contentModel.slots;
      return Array.isArray(slots[this.selectedCollectionName]);
    }
  }, {
    key: "collectionIsReadonly",
    get: function get() {
      if (!this.selectedCollectionName) throw new Error("no selectedCollectionName selected");
      var slots = this.contentModel.slots;
      if (!this.contentModel[this.selectedCollectionName]) throw new Error("incorrect collection!");
      return this.contentModel.meta && this.contentModel.meta[this.selectedCollectionName] && this.contentModel.meta[this.selectedCollectionName].readonly;
    }
  }, {
    key: "contentModel",
    get: function get() {
      if (!this.props.contentModel) throw new Error("missing contentmodel");
      return this.props.contentModel;
    }
  }, {
    key: "collection",
    get: function get() {
      if (!this.selectedCollectionName) throw new Error("no selectedCollectionName selected");
      var slots = this.contentModel.slots;
      if (!this.contentModel[this.selectedCollectionName]) throw new Error("incorrect collection!");
      return this.collectionIsArray ? this.contentModel[this.selectedCollectionName] : [this.contentModel[this.selectedCollectionName]];
    }
  }, {
    key: "availableCollectionNames",
    get: function get() {
      var slots = this.contentModel.slots;
      return (0, _keys2.default)(slots).filter(function (k) {
        return Array.isArray(slots[k]) || slots[k].prototype instanceof _baseContentmodel2.default;
      }).sort(function (a, b) {
        return Array.isArray(slots[b]) ? 1 : -1;
      });
    }
  }, {
    key: "CollectionItemContentModel",
    get: function get() {
      var slots = this.contentModel.slots;
      if (!this.selectedCollectionName) throw new Error("missing this.selectedCollectionName");
      var slot = slots[this.selectedCollectionName];
      return slot === _baseContentmodel2.default || Array.isArray(slot) && slot[0] === _baseContentmodel2.default ? this.contentModel.childConstructor || _baseContentmodel2.default : Array.isArray(slot) ? slot[0] : slot;
    }
  }, {
    key: "collectionSlots",
    get: function get() {
      if (this.CollectionItemContentModel === _baseContentmodel2.default) return {};
      var slots = this.CollectionItemContentModel._slots;
      if (!slots) throw new Error("collection contentModel missing _slots on constructor");
      return slots;
    }
  }, {
    key: "columnDefs",
    get: function get() {
      var _this4 = this;

      var contentModel = this.contentModel,
          selectedCollectionName = this.selectedCollectionName,
          collection = this.collection,
          newItem = this.newItem,
          viewItem = this.viewItem,
          editItem = this.editItem,
          collectionIsArray = this.collectionIsArray,
          slots = this.collectionSlots,
          collectionIsReadonly = this.collectionIsReadonly,
          CollectionItemContentModel = this.CollectionItemContentModel,
          _props = this.props,
          editorViewStore = _props.editorViewStore,
          modalViewStore = _props.modalViewStore;

      var defs = void 0;
      if (CollectionItemContentModel === _baseContentmodel2.default) {
        defs = [{ headerName: "Type", field: "type" }];
      }
      if (!defs) {
        var collectionSlotKeys = (0, _keys2.default)(slots).filter(function (k) {
          return k.charAt(0) !== "_" && k.charAt(0) !== "$";
        });
        defs = collectionSlotKeys.map(function (k) {
          var isArray = Array.isArray(slots[k]);
          if (isArray) {
            // return { headerName: "["+k+"]", field: k + ".length" }
            return { headerName: _this4.formatTitle(k), cellRenderer: function cellRenderer(params) {
                var item = params.data;
                var arr = item[k];
                var node = params.node;

                var div = document.createElement('div');
                div.style.textAlign = 'center';
                if (!item[k]) return div;

                var view = document.createElement('span');
                view.innerHTML = "" + arr.length;

                var view2 = document.createElement('span');
                view2.style.cursor = 'pointer';
                view2.title = 'View Collection';
                view2.innerHTML = ' <span class="ag-grid-view-item ag-grid-icon-item"></span>';
                item[k] && view2.addEventListener('click', function (e) {
                  viewItem(item, { onlyShow: [k], forceFullEditor: true });
                  editorViewStore.stopEditing();
                });

                div.appendChild(view);
                div.appendChild(view2);

                return div;
              } };
          } else {
            var isReference = slots[k] != null && (slots[k] instanceof _baseContentmodel2.default || slots[k] === _baseContentmodel2.default || slots[k].prototype instanceof _baseContentmodel2.default);
            var isObject = !isReference && (0, _typeof3.default)(slots[k]) === "object";
            if (!isReference) {
              return { headerName: _this4.formatTitle(k), field: k };
            } else {
              return { headerName: _this4.formatTitle(k), cellRenderer: function cellRenderer(params) {
                  var item = params.data;
                  var node = params.node;

                  var div = document.createElement('div');
                  div.style.textAlign = 'center';
                  if (!item[k]) return div;

                  var view = document.createElement('span');
                  view.innerHTML = item[k].id;

                  var view2 = document.createElement('span');
                  view2.style.cursor = 'pointer';
                  view2.title = 'View Item';
                  view2.innerHTML = ' <span class="ag-grid-view-item ag-grid-icon-item"></span>';
                  item[k] && view2.addEventListener('click', function (e) {
                    viewItem(item[k]);
                    editorViewStore.stopEditing();
                  });

                  var edit = document.createElement('span');
                  edit.style.cursor = 'pointer';
                  edit.title = 'Edit Item';
                  edit.innerHTML = ' <span class="ag-grid-edit-item ag-grid-icon-item"></span>';
                  edit.addEventListener('click', function (e) {
                    return editItem(item[k], node);
                  });

                  div.appendChild(view);
                  //!item[k].readonly && div.appendChild(view2)
                  div.appendChild(view2);
                  !item[k].readonly && div.appendChild(edit);

                  return div;
                } };
            }
          }
        });
        if (collection && collection[0] && collection[0]._dateEdited) {
          defs.push({ headerName: 'Date Added', field: '_dateAdded' });
          defs.push({ headerName: 'Date Edited', field: '_dateEdited' });
        }
      }
      defs.unshift({ headerName: "ID", field: "idOrDisplayName", sort: 'asc' });
      defs.unshift({
        headerName: "",
        suppressSorting: true,
        suppressMenu: true,
        width: 115,
        headerCellRenderer: collectionIsArray && !collectionIsReadonly ? function (params) {
          var add = document.createElement('span');
          add.style.cursor = 'pointer';
          add.title = 'Add Item';
          add.className = 'item-action';
          add.innerHTML = ' <span class="ag-grid-add-item ag-grid-icon-item"></span>';
          add.addEventListener('click', function (e) {
            return newItem();
          });
          return add;
        } : null,
        cellRenderer: function cellRenderer(params) {
          var item = params.data;
          var node = params.node;
          // if( item.readonly ) return '';
          var div = document.createElement('div');
          div.style.textAlign = 'center';

          var moveUp = document.createElement('span');
          moveUp.style.cursor = 'pointer';
          moveUp.title = 'Move Up';
          moveUp.className = 'item-action';
          moveUp.innerHTML = ' <span class="ag-grid-move-item-up ag-grid-icon-item"></span>';
          moveUp.addEventListener('click', function (e) {
            var contentModelIndex = collection.findIndex(function (cm) {
              return cm === item;
            });
            if (contentModelIndex !== 0) {
              collection.splice(contentModelIndex - 1, 0, collection.splice(contentModelIndex, 1)[0]);
              contentModel.saveEntity();
              _this4.updateGrid();
            }
          });

          var moveDown = document.createElement('span');
          moveDown.style.cursor = 'pointer';
          moveDown.title = 'Move Down';
          moveDown.className = 'item-action';
          moveDown.innerHTML = ' <span class="ag-grid-move-item-down ag-grid-icon-item"></span>';
          moveDown.addEventListener('click', function (e) {
            var contentModelIndex = collection.findIndex(function (cm) {
              return cm === item;
            });
            if (contentModelIndex !== collection.length - 1) {
              collection.splice(contentModelIndex + 1, 0, collection.splice(contentModelIndex, 1)[0]);
              contentModel.saveEntity();
              _this4.updateGrid();
            }
          });

          var view = document.createElement('span');
          view.style.cursor = 'pointer';
          view.title = 'View Item';
          view.className = 'item-action';
          view.innerHTML = ' <span class="ag-grid-view-item ag-grid-icon-item"></span>';
          view.addEventListener('click', function (e) {
            viewItem(item);
            editorViewStore.stopEditing();
          });

          var edit = document.createElement('span');
          edit.style.cursor = 'pointer';
          edit.title = 'Edit Item';
          edit.className = 'item-action';
          edit.innerHTML = ' <span class="ag-grid-edit-item ag-grid-icon-item"></span>';
          edit.addEventListener('click', function (e) {
            return editItem(item, node);
          });

          var clone = document.createElement('span');
          clone.style.cursor = 'pointer';
          clone.title = 'Clone Item';
          clone.className = 'item-action';
          clone.innerHTML = ' C';
          clone.addEventListener('click', function (e) {
            return item.cloneEntity();
          });

          var remove = document.createElement('span');
          remove.style.cursor = 'pointer';
          remove.title = 'Remove Item';
          remove.className = 'item-action';
          remove.innerHTML = ' <span class="ag-grid-delete-item ag-grid-icon-item"></span>';
          remove.addEventListener('click', (0, _mobx.action)(function (e) {
            //@TODO move most of this to base contentmodel
            var contentModelIndex = collection.findIndex(function (cm) {
              return cm === item;
            });

            var itemToDelete = collection[contentModelIndex];

            // System.Types and Orphans are the only places you can permanently delete entities with the grid editor
            var permanentDelete = contentModel.type === "TypeContentModel" || contentModel.type === "OrphansContentModel";

            if (permanentDelete) {
              item.deleteEntity(function () {
                _this4.updateGrid();
                modalViewStore.resetModal();
              });
            } else {
              modalViewStore.setModal({
                title: "Remove " + item.uniqueDisplayName,
                message: React.createElement(
                  "div",
                  null,
                  "Remove ",
                  item.uniqueDisplayName,
                  " from ",
                  contentModel.uniqueDisplayName + "." + selectedCollectionName + " collection",
                  "?"
                ),
                confirmLabel: 'Remove',
                confirmBtnClass: 'green delete-a',
                cancelLabel: 'Cancel',
                cancelBtnClass: 'red times-b',
                onConfirmFunc: function onConfirmFunc() {
                  collection.splice(contentModelIndex, 1);
                  contentModel.saveEntity();
                  modalViewStore.resetModal();
                }
              });
            }
          }));

          !collectionIsReadonly && div.appendChild(moveUp);
          !collectionIsReadonly && div.appendChild(moveDown);
          !item.readonly && !collectionIsReadonly && div.appendChild(edit);
          !item.constructor.Synthetic && div.appendChild(clone);
          /*!item.readonly && */div.appendChild(view);
          !collectionIsReadonly && div.appendChild(remove);

          return div;
        }
      });
      return defs;
    }
  }]);
  return ViewStore;
}(_editor.EditorViewStore), (_applyDecoratedDescriptor(_class.prototype, "viewMap", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "viewMap"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "api", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedCollectionName", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "collectionIsArray", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collectionIsArray"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collectionIsReadonly", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collectionIsReadonly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentModel", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "contentModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collection", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableCollectionNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "availableCollectionNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "CollectionItemContentModel", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "CollectionItemContentModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collectionSlots", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collectionSlots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "columnDefs", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "columnDefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCollection", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setCollection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateGrid", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateGrid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newItem", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "newItem"), _class.prototype)), _class));
var GridEditorView = exports.GridEditorView = (_dec5 = (0, _mobxReact.inject)("modalViewStore"), _dec6 = (0, _mobxReact.inject)("editorViewStore"), _dec5(_class3 = _dec6(_class3 = (0, _mobxReact.observer)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(GridEditorView, _BaseComponent);

  function GridEditorView() {
    (0, _classCallCheck3.default)(this, GridEditorView);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (GridEditorView.__proto__ || (0, _getPrototypeOf2.default)(GridEditorView)).apply(this, arguments));

    _this5.api = null;


    _this5.state = {
      sizeHandler: null,
      height: 0
    };
    return _this5;
  }

  (0, _createClass3.default)(GridEditorView, [{
    key: "onGridReady",
    value: function onGridReady(params) {
      this.viewStore.api = this.api = params.api;
    }
  }, {
    key: "resize",
    value: function resize() {
      var cm = this.viewStore.contentModel;
      this.setState({ height: cm && cm.id === 'Configuration' ? window.innerHeight - 130 : window.innerHeight - 75 }); //TODO: height values should not be hardcoded
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var contentModel = this.props.contentModel;

      window.GRIDUPDATE = window.GRIDUPDATE || {};
      if (window.GRIDUPDATE[contentModel.id]) {
        delete window.GRIDUPDATE[contentModel.id];
      }

      if (this.state.sizeHandler) {
        window.removeEventListener('resize', this.state.sizeHandler);
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var contentModel = this.props.contentModel;

      window.GRIDUPDATE = window.GRIDUPDATE || {};
      window.GRIDUPDATE[contentModel.id] = this;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var resizer = this.resize.bind(this);
      resizer();
      window.addEventListener('resize', resizer);
      this.state.sizeHandler = resizer;
    }
  }, {
    key: "render",
    value: function render() {
      var viewStore = this.viewStore,
          _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          collection = _viewStore.collection,
          columnDefs = _viewStore.columnDefs,
          contentModel = _viewStore.contentModel,
          goBack = _viewStore.goBack,
          availableCollectionNames = _viewStore.availableCollectionNames,
          selectedCollectionName = _viewStore.selectedCollectionName,
          setCollection = _viewStore.setCollection,
          collectionIsArray = _viewStore.collectionIsArray,
          editItem = _viewStore.editItem,
          viewItem = _viewStore.viewItem,
          newItem = _viewStore.newItem,
          options = _viewStore.options,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          isRoot = _viewStore.isRoot,
          editorViewStore = this.props.editorViewStore,
          height = this.state.height;


      return React.createElement(
        "div",
        null,
        isRoot && React.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        SelectedView ? React.createElement(SelectedView, null) : React.createElement(
          "div",
          { className: "ag-fresh round GridWrapper" },
          React.createElement(
            "div",
            { style: { height: height } },
            React.createElement(_agGridReact.AgGridReact, {
              onGridReady: this.onGridReady.bind(this)
              // listen for events with React callbacks
              // onRowSelected={onRowSelected}
              , onRowDoubleClicked: function onRowDoubleClicked(params) {
                viewItem(params.data, { forceFullEditor: true });
                editorViewStore.stopEditing();
              }
              // column definitions and row data are immutable, the grid
              // will update when these lists change
              , columnDefs: columnDefs,
              rowData: collection.slice()
              // or provide props the old way with no binding
              , rowSelection: "multiple",
              enableSorting: "true",
              suppressCellSelection: "true",
              suppressRowClickSelection: "true",
              enableFilter: "true",
              rowHeight: "26"
            })
          )
        )
      );
    }
  }]);
  return GridEditorView;
}(_baseComponent2.default), _class4.ViewStore = ViewStore, _temp)) || _class3) || _class3) || _class3);
var Component = exports.Component = GridEditorView;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getRandomIntInclusive, "getRandomIntInclusive", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(ViewStore, "ViewStore", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(GridEditorView, "GridEditorView", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/core_modules/collection-grid-editor/index.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js
// module chunks = 0